@typeparam T
@import { type Depth } from "@source-crafter/xzor-ui"

@code {
  items: Iterable<T> = [];
  /** No surface by default, to sit inside a `Panel`; give it one when it stands alone. */
  depth?: Depth;
}

<ul class="xz-list" data-depth="@depth">
  @for (const item of items) {
    <li>@slot:item(item as T) { @String(item) }</li>
  }
</ul>
